import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit, signal } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import { TmpStatus } from '../tmp-status/tmp-status';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PlayersService } from '../../../services/players/players';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { merge, take } from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { Downtime } from '../../../../core/services/times/downtime';
import { ListQuest } from '../../../services/lists/list-quest';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { WindowIncorrectPassword } from '../../../dialogs/window-incorrect-password/window-incorrect-password';
import { MatIconModule } from '@angular/material/icon';
import { AllStatus } from '../../../../core/services/status/all-status';

@Component({
  selector: 'app-tmp-game',
  imports: [MatCardModule, MatButtonModule, 
    MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatIconModule, TranslatePipe],
  templateUrl: './tmp-game.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './tmp-game.scss'
})
export class TmpGame implements OnInit{
  players = inject(PlayersService);
  router = inject(Router);
  @Input() data: any;
  pass = new FormControl('');
  readonly dialog = inject(MatDialog);
  quests = inject(ListQuest);
  errorMessage = signal('txtNull');
  downtime = inject(Downtime);

  isNotClick: boolean = true;
  allStatus$ = inject(AllStatus);

  translate = inject(TranslateService);
  txtDialog: any;
  subscriptionCL: import("rxjs").Subscription;

  constructor(private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.isNotClick = true;
    this.loadTranslateText();
    this.subscriptionCL = this.allStatus$.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.allStatus$.setChangeLanguage(false);
        this.loadTranslateText();
      }
    });   
    if(this.data.password_required){
      this.pass.setValidators([Validators.required]);
      merge(this.pass.statusChanges, this.pass.valueChanges)
        .pipe(take(1))
        .subscribe(() => this.updateErrorMessage());
    }
  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }

  updateErrorMessage() {
    if (this.pass.hasError('required')) {
      this.errorMessage.set('txtCodeEmpty');
    } else {
      this.errorMessage.set('txtNull');
    }
  }
  

  switch(data: any){
    let isDisable: boolean = false;
    if(data.stage_slug !== 'waiting'){
      isDisable = true;
    }
    if(data.password_required){
      if(this.pass.value?.length === 0){
        isDisable = true;
      }
    }
    if(data.maximum_players === data.number_of_players){
     isDisable = true; 
    }
    return isDisable;
  }

  isOpenRoom(data: any){
    let open: boolean = true;
    if(data.maximum_players === data.number_of_players){
     open = false; 
    }
    return open;

  }

  goToGame(data: any){
    this.isNotClick = false;
    this.allStatus$.textSpinner = this.txtDialog.txtJoining;
    this.allStatus$.setDisplayProgressSpinner(true);
    const uuid = data.uuid;
    this.downtime.refreshTimer();
    if(data.password_required){
      if(this.pass.value?.length as number > 0){
        this.players.createPlayerInRoom(data, false,this.pass.value as string).pipe(take(1)).subscribe({
          next: ()=> {this.quests.clearStorage();this.router.navigate([`/waiting/${uuid}`]);sessionStorage.setItem("typeGame", JSON.stringify('quest'));},
          error: (err) => {
            this.isNotClick = true;
            this.allStatus$.setDisplayProgressSpinner(false);
            this.allStatus$.textSpinner = '';
            const dialogConfig = new MatDialogConfig();
            dialogConfig.panelClass = 'nutri-templs';
            dialogConfig.backdropClass = 'nutri-templs-backdrop';                
            const dialogRef = this.dialog.open(WindowIncorrectPassword, dialogConfig);
            this.errorMessage.set(`txtCodeWrong`)
          }
        });
      }else{
        this.allStatus$.setDisplayProgressSpinner(false);
        this.allStatus$.textSpinner = '';        
        this.isNotClick = true;
        this.errorMessage.set(`txtCodeEmpty`);
        this.ref.markForCheck();
      }
      
    }else{ 
      this.players.createPlayerInRoom(data).pipe(take(1)).subscribe(()=> {this.router.navigate([`/waiting/${uuid}`]);sessionStorage.setItem("typeGame", JSON.stringify('quest'));});
    }
  }

}
